import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const SoftwareSelectionCard = ({ title, description, icon, route, isSelected = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(route);
  };

  return (
    <div 
      className={`software-card ${isSelected ? 'software-card--selected' : ''}`} 
      onClick={handleClick}
    >
      <div className="software-card__icon">
        {icon}
      </div>
      <h3 className="software-card__title">{title}</h3>
      <p className="software-card__description">{description}</p>
    </div>
  );
};

export default SoftwareSelectionCard; 